/** Elegant violet “strong first column” table theme (shared by Ops + Flight Entry). */

export const CHARTER_TABLE = {
  violet: '#6B0F5C',
  violetAlt: '#7D1A6D',
  headerText: '#A63D8C',
  zebraA: '#E8EEF2',
  zebraB: '#FFFFFF',
  selectedBg: 'rgba(107, 15, 92, 0.14)',
  selectedHover: 'rgba(107, 15, 92, 0.22)',
  zebraAHover: '#DCE5EB',
  zebraBHover: '#F5F7F9'
};

export const charterTableContainerSx = (fillHeight = false) => ({
  flex: fillHeight ? '1 1 0%' : '0 0 auto',
  alignSelf: 'stretch',
  width: '100%',
  minHeight: fillHeight ? 0 : undefined,
  height: fillHeight ? 0 : undefined,
  overflow: 'auto',
  border: 'none',
  borderRadius: 1,
  bgcolor: CHARTER_TABLE.zebraB,
  boxShadow: 'none',
  ...(fillHeight
    ? {
        backgroundImage: `repeating-linear-gradient(to bottom, ${CHARTER_TABLE.zebraA} 0 56px, ${CHARTER_TABLE.zebraB} 56px 112px)`,
        backgroundAttachment: 'local',
        backgroundPosition: '0 40px'
      }
    : {})
});

export const charterHeaderCellSx = (isFirst = false) => ({
  fontWeight: 700,
  fontSize: '0.75rem',
  py: 1,
  px: 1,
  borderBottom: 'none',
  borderRight: 'none',
  color: isFirst ? '#FFFFFF' : CHARTER_TABLE.headerText,
  bgcolor: isFirst ? CHARTER_TABLE.violet : '#FFFFFF',
  textAlign: isFirst ? 'left' : 'center',
  letterSpacing: 0.2,
  position: 'sticky',
  top: 0,
  zIndex: isFirst ? 3 : 2
});

export const charterBodyRowSx = (index, isSelected = false) => {
  const even = index % 2 === 0;
  return {
    cursor: 'pointer',
    height: 56,
    backgroundColor: isSelected
      ? CHARTER_TABLE.selectedBg
      : even
        ? CHARTER_TABLE.zebraA
        : CHARTER_TABLE.zebraB,
    '&:hover': {
      backgroundColor: isSelected
        ? CHARTER_TABLE.selectedHover
        : even
          ? CHARTER_TABLE.zebraAHover
          : CHARTER_TABLE.zebraBHover
    },
    '& td': {
      borderBottom: 'none'
    }
  };
};

export const charterFirstCellSx = (index, isSelected = false) => {
  const even = index % 2 === 0;
  return {
    fontSize: '0.75rem',
    fontWeight: 600,
    py: 0.75,
    px: 1,
    color: '#FFFFFF',
    bgcolor: isSelected
      ? '#5A0C4D'
      : even
        ? CHARTER_TABLE.violet
        : CHARTER_TABLE.violetAlt,
    borderBottom: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };
};

export const charterDataCellSx = (index) => {
  const even = index % 2 === 0;
  return {
    fontSize: '0.75rem',
    fontWeight: even ? 700 : 500,
    py: 0.75,
    px: 1,
    textAlign: 'center',
    color: 'text.primary',
    borderBottom: 'none'
  };
};

export const charterPadRowSx = (index) => {
  const even = index % 2 === 0;
  return {
    height: 56,
    pointerEvents: 'none',
    backgroundColor: even ? CHARTER_TABLE.zebraA : CHARTER_TABLE.zebraB,
    '& td': { borderBottom: 'none' }
  };
};
